import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import ImageIcon from '@mui/icons-material/Image';
import { Button, Grid, IconButton, TextField, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from '@mui/material/Divider';
import React, { useState, useRef } from "react";
import { SITEWEB_SERVER_BASE_URL } from "../../util/apiClient";
import { IEditionApplication } from './interface';

interface IEddProps {
  editionApplication: IEditionApplication;
  setEditionApplication: (x: IEditionApplication) => void;
  setSelectedPhoto: (x: any) => void;
  arrayToEdit: any;
  setArrayToEdit: (x: any) => void;
}


const Edit = (props: IEddProps) => {

  //props
  const {
    editionApplication,
    setEditionApplication,
    setSelectedPhoto,
    arrayToEdit,
    setArrayToEdit
  } = props


  //hooks
  const selectPhoto: any = useRef(null);
  const [image, setImage] = useState<string>("");

  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setEditionApplication({ ...editionApplication, [name]: value })
  }

  //Editer une fonctionnalité
  const handleFonctionnaliteChange = (event: any, index: number) => {
    const { name, value } = event.target;
    const updatedState: any = [...arrayToEdit];
    updatedState[index] = value;
    setArrayToEdit(updatedState);
  };

  //ajouter une ligne de fonctionnalité
  const handleAddRowFonctionnalite = () => {
    const newData = [...arrayToEdit]
    setArrayToEdit([...newData, ""])
  }

  // supprimer une ligne de fonctionnalité
  const handleFonctionnaliteRowDelete = (currentIndex: number) => {
    let newData = [...arrayToEdit]
    const res = newData.filter((item, index) => index !== currentIndex)
    setArrayToEdit(res)
  };


  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={6} xs={12} sm={6}>
          <TextField
            fullWidth
            size="small"
            name="libApp"
            label="libellé application"
            value={editionApplication.libApp}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item md={6} xs={12} sm={6}>
          <TextField
            fullWidth
            size="small"
            name="descriptionApp"
            label="Description"
            value={editionApplication.descriptionApp}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item md={6} xs={12} sm={6}>
          <TextField
            fullWidth
            size="small"
            name="lienApp"
            label="lien du site web"
            value={editionApplication.lienApp}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item md={6} xs={12} sm={6}>
          <TextField
            fullWidth
            size="small"
            name="lienPlaystore"
            label="Lien de téléchargement de l'application mobile android"
            value={editionApplication.lienPlaystore}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item md={6} xs={12} sm={6}>
          <TextField
            fullWidth
            size="small"
            name="lienAppStore"
            label="Lien de téléchargement de l'application mobile ios"
            value={editionApplication.lienAppStore}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item md={6} xs={12} sm={6}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >

            <Grid item md={12} xs={12} sm={12}>
              <img
                src={
                  Object.keys(image).length > 0
                    ? image
                    : `${SITEWEB_SERVER_BASE_URL}/appImage/${editionApplication.logoApp}`
                }
                style={{ width: "10vw", height: "20vh" }}
              />
            </Grid>

            <Grid item md={12} xs={12} sm={12}>
              <Tooltip title="Charger l'image">
                <Button
                  variant="outlined"
                  color="primary"
                  component="label"
                  startIcon={<ImageIcon />}
                  style={{ marginTop: 10 }}
                  onClick={() => {
                    selectPhoto?.current?.click();
                  }}
                >
                  Charger le logo
                </Button>
              </Tooltip>
              <input
                hidden
                multiple
                type="file"
                name="pieceJointe"
                ref={selectPhoto}
                onChange={(e: any) => {
                  const files = e.target.files[0];
                  if (files) {
                    const img = URL.createObjectURL(files);
                    setImage(img);
                    setSelectedPhoto(e.target.files[0]);
                  }
                }}
              />
            </Grid>

            <Grid item md={12} xs={12} sm={12}>
              <Divider />
            </Grid>

            {arrayToEdit?.map((item: string, index: number) => (
              <Grid key={index} item md={12} xs={12} sm={12}>
                <TextField
                  // fullWidth
                  // name="fonctionnalite"
                  style={{ width: "90%" }}
                  label="Fonctionnalité"
                  value={item}
                  onChange={(e) => handleFonctionnaliteChange(e, index)}
                />
                <Tooltip title="Supprimer">
                  <IconButton
                    onClick={() => handleFonctionnaliteRowDelete(index)}
                    style={{ marginTop: 10 }}
                  >
                    <DeleteIcon color="error" />
                  </IconButton>
                </Tooltip>
              </Grid>
            ))}

            <Grid item md={12} xs={12} sm={12}>
              <Tooltip title="Ajouter une fonctionnalité">
                <Button
                  onClick={handleAddRowFonctionnalite}
                  startIcon={<AddIcon color="primary" />}
                >
                  Ajouter une nouvelle fonctionnalité
                </Button>
              </Tooltip>
            </Grid>
          </Grid>
        </Grid>

        <Grid item md={6} xs={12} sm={6}>
          <Grid
            container
            spacing={2}
            direction="row"
          >
            <Grid item md={12} xs={12} sm={12}>
              <TextField
                // fullWidth
                style={{ width: "90%" }}
                multiline
                minRows={10}
                name="texteComplet"
                label="Saisir le texte complet"
                value={editionApplication.texteComplet}
                onChange={handleInputChange}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Edit;




